// import { Link } from "react-router-dom";
import styled from "styled-components";
// import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";
import { Button } from "../../pages/home/components/HeroSession.js/HeroSession.styles";

const BetaDetail = () => {
  return (

      <FormContainer>
        <InputContainer>
          <div>
            <label>Where do you work currently?</label>
            <input placeholder="eg Coca Cola" />
          </div>
          <div>
            <label>Monthly Salary?</label>
            <input placeholder="eg 500,000" />
          </div>
          <div>
            <label>Country of Destination</label>
            <input placeholder="eg, Dubai" />
          </div>
          <div>
            <label>Duration of stay</label>
            <input placeholder="eg, 2 weeks" />
          </div>
          <div>
            <label>Do you have an international Passport?</label>
            <input placeholder="" />
          </div>
          <div>
            <label>Have you traveled out of the country before?</label>
            <input placeholder="" />
          </div>
        </InputContainer>
        <div className="submit__button">
          <Button
            style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
            to="/contact"
          >
            Finish
          </Button>
        </div>
      </FormContainer>
  );
};

export default BetaDetail; 

export const FormContainer = styled.div`
  // background: red;
  margin-top: 2rem;
  // background: red;
  padding-left: 3rem;
  font-size: 20px;
  div label {
    display: block;
  }
  .message__input label {
    margin-bottom: 1.5rem;
  }
  .message__input textarea {
    font-size: 16px;
    color: red;
    margin-top: 1rem;
    margin-bottom: 24px;
    border: none;
    outline: none;
    border-radius: 5px;
    border: 1px solid #c4c4c4;
    width: 90%;
    // height: 1rem;
    transform: translateY(-1rem);
  }

  div a {
    color: ${({ theme }) => theme.colors.primary};
  }
  p:last-child {
    text-align: center;
  }

  .message__input label:nth-of-type(2) {
    margin-top: 1rem;
    color: #c4c4c4;
    font-size: 16px;
  }
  .submit__button {
    margin-right: 3rem;
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 991px) {
    margin-bottom: 5rem;
  }
  @media screen and (max-width: 579px) {
    padding-left: 1rem;

    .message__input label:nth-of-type(2) {
      margin-top: 1rem;
    }
    .message__input textarea {
      //   font-size: px;
      color: #c4c4c4;
      margin-top: 1rem;
      margin-bottom: 24px;
      border: none;
      outline: none;
      border: 1px solid #c4c4c4;
      width: 95%;
      background-color: #ececec;
      border-radius: 8px;
      height: 195px;
    }
    .submit__button {
      display: flex;
      justify-content: center;
    }
    .footer__info {
      display: none;
    }
  }
`;

export const InputContainer = styled.div`
  margin-right: 2rem;
  margin-left; 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  // gap: 2rem;
  label {
    display: block;
  }
  input {
    font-size: 16px;
    color: #c4c4c4;
    opacity: 0.5;
    margin-top: 1rem;
    margin-bottom: 24px;
    border: none;
    outline: none;
    border-bottom: 1px solid #c4c4c4;
    padding-right: 2rem;
    width: 60%;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    input {
    }
  }
  @media screen and (max-width: 579px) {
      input{
          width: 95%;
      }
  }
`;
export const ContactIcon = styled.div`
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  gap: 40px;
`;
